import { Base } from "../../framework/base";
import { modifyDateField, modifyUserNameField } from "./taskTypeCol";
import { TaskDataRowDataType, EnumHelper } from "../enums";
import { Translations } from "../translations";
import { TaskDataRowColIcon } from "./taskDataRowColIcon";
var TaskDataRowCol = /** @class */ (function () {
    function TaskDataRowCol(obj) {
        this.field = obj && obj.field || "";
        this.valueStr = obj && obj.valueStr || "";
        this.valueNbr = obj && obj.valueNbr || null;
        this.icon = null;
        if (obj && obj.icon) {
            this.icon = new TaskDataRowColIcon(obj.icon);
        }
    }
    TaskDataRowCol.prototype.getHash = function () {
        var _a, _b;
        return ((_a = this.field) !== null && _a !== void 0 ? _a : "") + "#" + ((_b = this.valueStr) !== null && _b !== void 0 ? _b : "") + "#" + (this.valueNbr ? this.valueNbr.toString() : "");
    };
    TaskDataRowCol.crateTaskDataRowCol = function (field, valueStr, valueNbr) {
        var result = new TaskDataRowCol();
        result.field = field;
        result.valueStr = valueStr;
        result.valueNbr = valueNbr;
        return result;
    };
    TaskDataRowCol.getExpressionFieldTaskDataRowCols = function (items) {
        if (Base.isNullOrUndefined(items))
            return [];
        var result = items.slice(0);
        if (items.length > 1) {
            result.sort(function (a, b) { return (Base.isNullOrUndefined(a) || Base.isNullOrUndefined(b) || Base.isNullOrUndefined(a.field) || Base.isNullOrUndefined(b.field)) ? 0 : (-1 * Base.numCompare(a.field.length, b.field.length)); });
        }
        return result;
    };
    TaskDataRowCol.getExpressionFieldTaskTypeCols = function (items) {
        if (!items)
            return [];
        var result = items.slice(0);
        if (items.length > 1) {
            result.sort(function (a, b) { return (Base.isNullOrUndefined(a) || Base.isNullOrUndefined(b) || Base.isNullOrUndefined(a.field) || Base.isNullOrUndefined(b.field)) ? 0 : (-1 * Base.numCompare(a.field.length, b.field.length)); });
        }
        return result;
    };
    TaskDataRowCol.getExpressionsFieldNames = function (typeCols, expression) {
        if (!expression || !typeCols)
            return [];
        var result = [];
        var cols = TaskDataRowCol.getExpressionFieldTaskTypeCols(typeCols);
        for (var i = 0; i < cols.length; i++) {
            var col = cols[i];
            var index = expression.indexOf(col.field);
            if (index < 0)
                continue;
            result.push(col.field);
        }
        return result;
    };
    TaskDataRowCol.compareTaskDataRowCols = function (a, b, typeCol, asc) {
        var multiplier = asc ? 1 : -1;
        if (Base.isNullOrUndefined(a))
            return multiplier * (Base.isNullOrUndefined(b) ? 0 : -1);
        if (Base.isNullOrUndefined(b))
            return multiplier * 1;
        return multiplier *
            (typeCol.dataType === TaskDataRowDataType.String
                ? Base.strCompare(a.valueStr, b.valueStr)
                : Base.numCompare(a.valueNbr, b.valueNbr));
    };
    TaskDataRowCol.strCompare = function (a, b, asc) {
        var multiplier = asc ? 1 : -1;
        if (Base.isNullOrUndefined(a))
            return multiplier * (Base.isNullOrUndefined(b) ? 0 : -1);
        if (Base.isNullOrUndefined(b))
            return multiplier * 1;
        return multiplier * Base.strCompare(a, b);
    };
    TaskDataRowCol.numCompare = function (a, b, asc) {
        var multiplier = asc ? 1 : -1;
        if (Base.isNullOrUndefined(a))
            return multiplier * (Base.isNullOrUndefined(b) ? 0 : -1);
        if (Base.isNullOrUndefined(b))
            return multiplier * 1;
        return multiplier * Base.numCompare(a, b);
    };
    TaskDataRowCol.evaluateStrExpressionFormat = function (expressionFormat, evalValue, defaultValue) {
        if (defaultValue === void 0) { defaultValue = null; }
        var defVal = !Base.isNullOrUndefined(defaultValue) ? defaultValue : evalValue;
        if (!expressionFormat)
            return defVal;
        var index = expressionFormat.indexOf("fieldValue");
        if (index < 0)
            return defVal;
        expressionFormat = expressionFormat.replace(/fieldValue/g, evalValue);
        try {
            /* eslint-disable no-eval */
            return eval(expressionFormat);
            /* eslint-enable no-eval */
        }
        catch (error) {
            console.log(expressionFormat, error);
            return defVal;
        }
    };
    TaskDataRowCol.getDefaultValueTaskDataRowCol = function (typeCol) {
        var result = new TaskDataRowCol();
        result.field = typeCol.field;
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.String)) {
            var optionValues = !Base.isNullOrUndefined(typeCol.options) && typeCol.options.length > 0
                ? typeCol.options
                : (!Base.isNullOrUndefined(typeCol.idOptions) && typeCol.idOptions.length > 0
                    ? typeCol.idOptions.map(function (i) { return i.id; })
                    : null);
            result.valueStr = !Base.isNullOrUndefined(optionValues)
                ? typeCol.defaultStr && optionValues.indexOf(typeCol.defaultStr) > -1 ? typeCol.defaultStr : (!typeCol.placeholder ? optionValues[0] : "")
                : typeCol.defaultStr ? typeCol.defaultStr : "";
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Integer) || EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Number)) {
            if (!Base.isNullOrUndefined(typeCol.defaultNbr)) {
                result.valueNbr = typeCol.defaultNbr;
            }
            else if (typeCol.required) {
                result.valueNbr = 0;
            }
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Time)) {
            if (typeCol.defaultStr) {
                var hasMinus = typeCol.defaultStr[0] === "-";
                var hasPlus = typeCol.defaultStr[0] === "+";
                if (hasMinus || hasPlus) {
                    var offset = typeCol.defaultStr.substring(1).toInteger();
                    result.valueNbr = Base.getNowUtcTime().addMinutes((hasMinus ? -1 : 1) * offset).getTime();
                }
                else {
                    result.valueNbr = typeCol.defaultStr.toUtcTime().getTime();
                }
            }
            else if (typeCol.required) {
                result.valueNbr = Base.getNowUtcTime().getTime();
            }
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Date)) {
            if (typeCol.defaultStr) {
                var hasMinus = typeCol.defaultStr[0] === "-";
                var hasPlus = typeCol.defaultStr[0] === "+";
                if (hasMinus || hasPlus) {
                    var offset = typeCol.defaultStr.substring(1).toInteger();
                    result.valueNbr = Base.getNowUtcDate().addDays((hasMinus ? -1 : 1) * offset).getTime();
                }
                else {
                    result.valueNbr = typeCol.defaultStr.toUtcDate().getTime();
                }
            }
            else if (typeCol.required) {
                result.valueNbr = Base.getNowUtcDate().getTime();
            }
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TimeSpan)) {
            if (typeCol.defaultStr) {
                result.valueNbr = typeCol.defaultStr.toTimeSpan();
            }
            else if (typeCol.required) {
                result.valueNbr = 0;
            }
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Boolean)) {
            if (typeCol.defaultStr) {
                result.valueNbr = Base.strToBool(typeCol.defaultStr) ? 1 : 0;
            }
            else if (typeCol.required) {
                result.valueNbr = 0;
            }
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.StringArray) || EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TreeStringArray)) {
            var optionValues = !Base.isNullOrUndefined(typeCol.options) && typeCol.options.length > 0
                ? typeCol.options
                : (!Base.isNullOrUndefined(typeCol.idOptions) && typeCol.idOptions.length > 0
                    ? typeCol.idOptions.map(function (i) { return i.id; })
                    : (!Base.isNullOrUndefined(typeCol.idNodeOptions) && typeCol.idNodeOptions.length > 0
                        ? typeCol.idNodeOptions.map(function (i) { return i.id; })
                        : null));
            var defaultValues_1 = typeCol.defaultStr
                ? JSON.parse(typeCol.defaultStr)
                : null;
            var defaultOptionsValues = optionValues && defaultValues_1
                ? optionValues.filter(function (i) { return defaultValues_1.indexOf(i) > -1; })
                : [];
            result.valueStr = optionValues
                ? defaultOptionsValues.length > 0 ? JSON.stringify(defaultOptionsValues) : (!typeCol.placeholder ? JSON.stringify([optionValues[0]]) : "[]")
                : defaultValues_1 ? JSON.stringify(defaultValues_1) : "[]";
        }
        return result;
    };
    TaskDataRowCol.getTaskDataRowColUiValue = function (typeCol, valueStr, valueNbr) {
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.String))
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, valueStr !== null && valueStr !== void 0 ? valueStr : "");
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Integer)) {
            var isValidNumber = !Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr);
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, isValidNumber ? valueNbr.toString(10) : "0", isValidNumber ? valueNbr.toLocaleFixed(0) : (typeCol.required ? "0" : ""));
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Number)) {
            var isValidNumber = !Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr);
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, isValidNumber ? valueNbr.toString(10) : "0", isValidNumber ? valueNbr.toLocaleFixed(typeCol.decimals) : (typeCol.required ? 0..toLocaleFixed(typeCol.decimals) : ""));
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Time)) {
            var isValidNumber = !Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr);
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, TaskDataRowCol.getTimeEvalValue(valueNbr), isValidNumber ? Base.utcTimeToTimeStr(valueNbr) : "");
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Date)) {
            var isValidNumber = !Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr);
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, TaskDataRowCol.getDateEvalValue(valueNbr), isValidNumber ? Base.utcTimeToDateStr(valueNbr) : "");
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TimeSpan)) {
            var isValidNumber = !Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr);
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, isValidNumber ? valueNbr.toString(10) : "0", isValidNumber ? Base.timeSpanToString(valueNbr) : "");
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Boolean)) {
            var isValidNumber = !Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr);
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, isValidNumber ? valueNbr.toString(10) : "0");
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.StringArray) || EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TreeStringArray))
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, valueStr !== null && valueStr !== void 0 ? valueStr : "");
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Signature))
            return TaskDataRowCol.evaluateStrExpressionFormat(typeCol.expressionFormat, valueStr !== null && valueStr !== void 0 ? valueStr : "");
        return "";
    };
    TaskDataRowCol.getTaskDataRowColDbValue = function (typeCol, valueStr, valueNbr) {
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.String) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.StringArray) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TreeStringArray) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Signature)) {
            return valueStr;
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Integer) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Boolean)) {
            return !Base.isNullOrUndefined(valueNbr) ? Math.floor(valueNbr) : null;
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Date)) {
            if (Base.isNullOrUndefined(valueNbr))
                return null;
            return Base.dateToUtcDate(new Date(valueNbr)).toISOString();
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Time)) {
            if (Base.isNullOrUndefined(valueNbr))
                return null;
            return new Date(valueNbr).toISOString();
        }
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TimeSpan))
            return valueNbr;
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Number))
            return !Base.isNullOrUndefined(valueNbr) ? Base.roundToDecimals(valueNbr, typeCol.decimals) : null;
        return null;
    };
    TaskDataRowCol.prototype.setTaskDataRowColValueFromDbValue = function (typeCol, value) {
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.String) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.StringArray) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TreeStringArray) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Signature)) {
            this.valueStr = value;
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Integer) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Boolean) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TimeSpan) ||
            EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Number)) {
            this.valueNbr = value;
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Date)) {
            this.valueNbr = null;
            if (Base.isNullOrUndefined(value))
                return;
            this.valueNbr = new Date(value).getTime();
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Time)) {
            this.valueNbr = null;
            if (Base.isNullOrUndefined(value))
                return;
            this.valueNbr = new Date(value).getTime();
        }
    };
    TaskDataRowCol.prototype.getTaskDataRowColListUiValue = function (typeCol, modifyUserName, modifyDate) {
        var dataCol = this;
        if (typeCol.field.equalIgnoreCase(modifyUserNameField)) {
            dataCol = TaskDataRowCol.crateTaskDataRowCol(typeCol.field, modifyUserName, 0);
        }
        else if (typeCol.field.equalIgnoreCase(modifyDateField)) {
            dataCol = TaskDataRowCol.crateTaskDataRowCol(typeCol.field, Base.timeToDateTimeStr(modifyDate), modifyDate);
        }
        var result = !Base.isNullOrUndefined(dataCol)
            ? TaskDataRowCol.getTaskDataRowColUiValue(typeCol, dataCol.valueStr, dataCol.valueNbr)
            : "";
        if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.Boolean)) {
            result = Base.strToBool(result) ? Translations.Yes : Translations.No;
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.String)) {
            if (typeCol.idOptions && typeCol.idOptions.length > 0) {
                var idOption = typeCol.idOptions.find(function (i) { return i.id === result; });
                if (idOption) {
                    result = idOption.title;
                }
                else {
                    result = "";
                }
            }
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.StringArray)) {
            if (typeCol.idOptions && typeCol.idOptions.length > 0 && !!result) {
                var array_1 = JSON.parse(result);
                var idOptions = typeCol.idOptions.filter(function (i) { return array_1.indexOf(i.id) > -1; });
                result = idOptions.map(function (i) { return i.title; }).join(", ");
            }
        }
        else if (EnumHelper.isEqual(typeCol.dataType, TaskDataRowDataType.TreeStringArray)) {
            if (typeCol.idNodeOptions && typeCol.idNodeOptions.length > 0 && !!result) {
                var array_2 = JSON.parse(result);
                var idOptions = typeCol.idNodeOptions.filter(function (i) { return array_2.indexOf(i.id) > -1; });
                result = idOptions.map(function (i) { return i.title; }).join(", ");
            }
        }
        return result;
    };
    TaskDataRowCol.prototype.matchesToFilter = function (lowFilter, typeCol, modifyUserName, modifyDate) {
        if (!typeCol)
            return false;
        return this.getTaskDataRowColListUiValue(typeCol, modifyUserName, modifyDate).toLowerCase().indexOf(lowFilter) > -1;
    };
    TaskDataRowCol.initializeValuesByType = function (typeCols, dataCols) {
        var result = [];
        var _loop_1 = function (typeCol) {
            var dataCol = dataCols.find(function (j) { return j.field === typeCol.field; });
            if (Base.isNullOrUndefined(dataCol)) {
                dataCol = TaskDataRowCol.getDefaultValueTaskDataRowCol(typeCol);
            }
            var newDataCol = new TaskDataRowCol(dataCol);
            newDataCol.valueStr = TaskDataRowCol.getTaskDataRowColUiValue(typeCol, dataCol.valueStr, dataCol.valueNbr);
            result.push(newDataCol);
        };
        for (var _i = 0, typeCols_1 = typeCols; _i < typeCols_1.length; _i++) {
            var typeCol = typeCols_1[_i];
            _loop_1(typeCol);
        }
        return result;
    };
    TaskDataRowCol.hasDefaultValues = function (typeCols, dataCols) {
        var _loop_2 = function (typeCol) {
            var dataCol = dataCols.find(function (j) { return j.field === typeCol.field; });
            if (Base.isNullOrUndefined(dataCol)) {
                return "continue";
            }
            var defaultDataCol = TaskDataRowCol.getDefaultValueTaskDataRowCol(typeCol);
            if (TaskDataRowCol.getTaskDataRowColUiValue(typeCol, dataCol.valueStr, dataCol.valueNbr) !== TaskDataRowCol.getTaskDataRowColUiValue(typeCol, defaultDataCol.valueStr, defaultDataCol.valueNbr)) {
                return { value: false };
            }
        };
        for (var _i = 0, typeCols_2 = typeCols; _i < typeCols_2.length; _i++) {
            var typeCol = typeCols_2[_i];
            var state_1 = _loop_2(typeCol);
            if (typeof state_1 === "object")
                return state_1.value;
        }
        return true;
    };
    TaskDataRowCol.getToBeSavedTaskDataRowCols = function (formCols, dataCols) {
        var savedFormCols = formCols.filter(function (i) { return i.isSaveDataType() && i.isSavedTaskDataField(); });
        return dataCols.filter(function (i) { return savedFormCols.find(function (j) { return j.field === i.field; }); });
    };
    TaskDataRowCol.getTimeEvalValue = function (valueNbr) {
        var result = "new Date()";
        if (!Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr)) {
            var date = new Date();
            date.setTime(valueNbr);
            result = "new Date(Date.UTC(0,0,0," + date.getUTCHours() + "," + date.getUTCMinutes() + "," + date.getUTCSeconds() + "," + date.getUTCMilliseconds() + "))";
        }
        return result;
    };
    TaskDataRowCol.getDateEvalValue = function (valueNbr) {
        var result = "new Date()";
        if (!Base.isNullOrUndefined(valueNbr) && !isNaN(valueNbr)) {
            var date = new Date();
            date.setTime(valueNbr);
            result = "new Date(Date.UTC(" + date.getUTCFullYear() + "," + date.getUTCMonth() + "," + date.getUTCDate() + ",0,0,0,0))";
        }
        return result;
    };
    return TaskDataRowCol;
}());
export { TaskDataRowCol };
var SaveTaskDataRowCol = /** @class */ (function () {
    function SaveTaskDataRowCol(obj) {
        this.field = obj && obj.field || "";
        this.valueStr = obj && obj.valueStr || "";
        this.valueNbr = obj && obj.valueNbr || null;
    }
    return SaveTaskDataRowCol;
}());
export { SaveTaskDataRowCol };
